import { render, staticRenderFns } from "./AddPilotagePractice.vue?vue&type=template&id=59be73b0"
import script from "./AddPilotagePractice.vue?vue&type=script&lang=ts"
export * from "./AddPilotagePractice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports